/**
 * Alsó erjesztésű   * PILS_PILSNER_PILSENER - Pils/Pilsner/Pilsener   * BOCK_BOK - Bock/Bok   * DRY_BEER - Dry Beer   * HELLES - Helles   * SCHWARZBIER - Schwarzbier   * KELLERBIER_OR_ZWICKELBIER - Kellerbier vagy Zwickelbier   * MARZEN_OKTOBERFEST - Märzen/Oktoberfest
 */
export type BottomFermented =
  | 'PILS_PILSNER_PILSENER'
  | 'BOCK_BOK'
  | 'DRY_BEER'
  | 'HELLES'
  | 'SCHWARZBIER'
  | 'KELLERBIER_OR_ZWICKELBIER'
  | 'MARZEN_OKTOBERFEST';

export const BottomFermented = {
  PilsPilsnerPilsener: 'PILS_PILSNER_PILSENER' as BottomFermented,
  BockBok: 'BOCK_BOK' as BottomFermented,
  DryBeer: 'DRY_BEER' as BottomFermented,
  Helles: 'HELLES' as BottomFermented,
  Schwarzbier: 'SCHWARZBIER' as BottomFermented,
  KellerbierOrZwickelbier: 'KELLERBIER_OR_ZWICKELBIER' as BottomFermented,
  MarzenOktoberfest: 'MARZEN_OKTOBERFEST' as BottomFermented,
};
